import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { IListField } from '@ispm/shared/interfaces/list-field.interface';
import { get } from 'lodash';

@Component({
  selector: 'gen-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListItemComponent implements OnInit {

  @Input()
  fields: Array<IListField>;

  @Input()
  item: any;

  @Input()
  classes: string = '';

  @Input()
  prioritizeAvailable: boolean;

  @Output()
  deleteActionEmit: EventEmitter<string> = new EventEmitter();

  public AutoClass: string = 'Auto_List_Item_';

  constructor() {
  }

  ngOnInit() {
    if (!this.fields) {
      return;
    }

    this.AutoClass += get(this.item, this.fields[0].path, get(this.item, this.fields[0].fallbackPath));
    this.AutoClass +=  '_' + this.fields.map(field => field.path).join('_');
  }

  public remove() {
    this.deleteActionEmit.emit();
  }
}
